const types = {
  FETCH_RESIDENT_OCCUPANCY: "FETCH_RESIDENT_OCCUPANCY",
};

export default types;
